import { render, staticRenderFns } from "./child-product-add-modal.vue?vue&type=template&id=7a504dc4&scoped=true&"
import script from "./child-product-add-modal.vue?vue&type=script&lang=js&"
export * from "./child-product-add-modal.vue?vue&type=script&lang=js&"
import style0 from "./child-product-add-modal.vue?vue&type=style&index=0&id=7a504dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a504dc4",
  null
  
)

export default component.exports